module.exports = __webpack_public_path__ + "assets/img/fish.626976fd.png";